export default __webpack_public_path__ + "static/media/survey.55806251.png";